import pinyinMatch from 'pinyin-match';

export function filterKeywordOptions(node, keyword) {
    if(!!~node.text.indexOf(keyword) || !!~node.text.toUpperCase().indexOf(keyword.toUpperCase())) {
        return true
      }
      if(pinyinMatch.match(node.label, keyword)) {
        return true
      }
  }



// WEBPACK FOOTER //
// ./src/lib/cascaderUtils.js